import { combineReducers } from 'redux';
import searchReducer from './searchReducer';
import toggleFormReducer from './toggleFormReducer';

export default combineReducers({
	input: searchReducer,
	form: toggleFormReducer
})